export function formatBlockId(blockId: number): string {
  if (blockId < 0 || blockId > 99999) {
    throw new Error("Block index must be between 0 and 99999");
  }
  const blockIdString = blockId.toString().padStart(5, "0");
  return Buffer.from(blockIdString).toString("base64");
}
